import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { appPath } from '../../../constants';
import Validator from '../../common/forms/Validator';
import { decodeCCList, extractCompanyPayload } from '../../../helpers/companies';
import Close from '../../common/ui/Close';
import SwitchRow from '../../common/forms/SwitchRow';
import Input from '../../common/forms/Input';
import FormActionButtons from '../../common/forms/FormActionButtons';

export default class CreateCompany extends Validator {
  static propTypes = {
    history: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    createNewCompany: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
  };

  initialState = {
    company_name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    net_terms: '',
    cc_invoices: '',
    is_individual: false,
    is_cc_exempt: false,
    use_custom_rate: false,
    allow_1099m_workers: false,
    owner_id: this.props.user.userid || 1
  };

  state = this.initialState;

  validationRules = {
    company_name: { required: true },
    address: { required: true },
    city: { required: true },
    state: { required: true },
    zip: { zipcode: true }
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleCCInvoices = event => {
    this.setState({
      cc_invoices: decodeCCList(event.target.value)
    });
  };

  handleSwitch = name => this.setState(prevState => ({ [name]: !prevState[name] }));

  cancelCreate = () => {
    this.setState(this.initialState);
    this._resetErrors();
    this.props.toggleModal();
  };

  createCompany = event => {
    event.preventDefault();
    event.persist();
    if (this.validate(this.validationRules)) {
      const { createNewCompany, history } = this.props;
      createNewCompany(extractCompanyPayload(this.state)).then(newCompany => {
        history.push(`/${appPath}/companies/${newCompany.id}`);
      });
    }
  };

  render () {
    const { isOpen, toggleModal, user } = this.props;
    console.log(user)
    const { company_name, address, city, state, zip, net_terms, cc_invoices, is_individual, is_cc_exempt, use_custom_rate, allow_1099m_workers, owner_id } = this.state;
    const errors = this.validationErrors;
    return (
      <Modal className='create-modal' isOpen={isOpen} toggle={toggleModal}>
        <div className='modal-header'>
          <div className='modal-title'>Create New Account</div>
          <Close onClick={toggleModal} />
        </div>
        <form className='modal-body' onSubmit={this.createCompany}>
          <Input onChange={this.handleChange} name='company_name' label='Company Name' value={company_name} error={errors.company_name} />
          <Input onChange={this.handleChange} name='address' label='Address' value={address} error={errors.address} />
          <Input onChange={this.handleChange} name='city' label='City' value={city} error={errors.city} />
          <Input onChange={this.handleChange} name='state' label='State' value={state} error={errors.state} />
          <Input onChange={this.handleChange} name='zip' label='Zip' value={zip} error={errors.zip} />
          <Input onChange={this.handleChange} name='net_terms' label='Net Terms' value={net_terms} type='number' />
          <Input onChange={this.handleCCInvoices} name='cc_invoices' label='CC on Invoice Email' value={cc_invoices} info='Please enter a comma-separated list of emails' />
          <input name='owner_id' hidden={true} value={owner_id} />
          <div className='form-group'>
            <SwitchRow disabled onChange={this.handleSwitch} checked={is_individual} label='Is Private Party?' />
          </div>

          <div className='form-group'>
            <SwitchRow checked={is_cc_exempt} onChange={() => this.handleSwitch('is_cc_exempt')} label='Credit Card Not Required' />
          </div>

          <div className='form-group'>
            <SwitchRow checked={use_custom_rate} onChange={() => this.handleSwitch('use_custom_rate')} label='Use Custom Rates' />
          </div>

          <div className='form-group'>
            <SwitchRow checked={allow_1099m_workers} onChange={() => this.handleSwitch('allow_1099m_workers')} label='Allow 1099M Workers' />
          </div>

          <FormActionButtons onClickCancel={this.cancelCreate} submitTitle='Create' />
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/companiesList/CreateCompany.js